// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5324":"ae1db1c7","6527":"8b2c3b00","6891":"871818c6"}[chunkId] + ".js";
};